<template>
  <div>
    <Top></Top>
    <div class="main">
      <h2>商品写真·撮影代行サービス</h2>
      <div class="txt">
        <p>ＥＣサイト販売はお客様にとって実際の商品が手に取れない為、写真で商品を判断するしかありません。商品写真は、最も売り上げを左右する重要な要素の一つです</p>
        <p>手間の掛かる商品撮影はお任せください。</p>
        <p>弊社の撮影スタジオにプロのカメラマンが常駐しており、ぜひご利用ください。</p>
        <span>
          <img src="../../assets/img/excel1.png" alt /> 撮影指示書
        </span>
      </div>
      <div class="jiage">
        <h3>撮影料金（1商品につき）</h3>
        <p>１枚:１２元</p>
        <p>２-５枚セット：４０元</p>
        <p style="  margin-bottom: 40px;">６-８枚セット：６０元</p>
        <p>モデル撮影</p>
        <p>モデル手配もお任せでください。モデルの費用はその都度見積もりをさせて頂きます。</p>
      </div>
      <div class="wuliao">
        <h3>無料サービス</h3>
        <h4>１、マネキン、トルソーの使用</h4>
        <p>アパレル商品の場合、平置きの写真だけではサイズや全体のイメージがわかりずらいことが多々有りますので、洋服などはより立体に、バックなどはマネキンに着用するとサイズ感が簡単にわかります。</p>
        <h4>２、スチーマーかけ</h4>
        <p>シワ映りが心配な衣類の撮影に、ぜひご活用ください。</p>
        <h4>３、反射素材</h4>
        <p>アクセサリー類など、反射素材の写真は撮影後修正などの必要あり、そちらも追加料金なしで対応いたします。</p>
        <h4>４、白抜き加工</h4>
        <p>ＥＣサイトにより白背景でなければならないことがあり、そちらの加工も無料でさせて頂きます。</p>
        <p>特別のご要望がない場合は基本すべて写真を黙認で白抜き加工して、お渡し致します。</p>
        <h4>５、写真のリネーム</h4>
        <p>撮影したままのファイル名は間違いなどが起こりやすいので、商品ごとの管理番号にリネームを無料で行います。</p>
        <h4>６、無料ロゴ付け</h4>
        <p>公開の写真は簡単に使われることが多々あります、そんなことを防ぐために画像にショップのロゴを入れるのが有用な手段として使われています。</p>
        <p>お客様にご要望があれば無料でお付けいたします。</p>
        <p style="margin-top:30px">その他記載していないサービスが必要な場合、お問い合わせください。</p>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";
export default {
  data() {
    return {};
  },
  components: {
    Top,
    Foot
  },
  methods: {}
};
</script>
<style lang='scss' scoped>
.main {
  width: 1200px;
  margin: 0 auto 150px;
  h2 {
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    margin: 120px 0 80px;
  }
  .txt {
    p {
      font-size: 22px;
      line-height: 40px;
      font-weight: 700;
    }
    span {
      font-size: 16px;
      font-weight: 700;
      line-height: 40px;
      color: #F3C622;
      cursor: pointer;
      img {
        vertical-align: middle;
      }
    }
  }
  .jiage {
    margin-top: 70px;

    p {
      font-size: 18px;
      margin-bottom: 15px;
    }
  }
  h3 {
    height: 70px;
    padding-left: 15px;
    font-size: 25px;
    background: #F3C622;
    color: #fff;
    line-height: 70px;
    font-weight: 700;
    margin-bottom: 40px;
  }
  .wuliao {
    font-size: 22px;
    h4 {
      font-weight: 700;
      margin: 30px 0 20px;
    }
    p {
      line-height: 40px;
    }
  }
}
</style>